import { gql } from "@apollo/client";

const SKIP_TOPIC = gql`
  mutation SkipTopic($id: ID!) {
    skipTopic(input: { id: $id }) {
      topic {
        id
      }
    }
  }
`;

export default SKIP_TOPIC;
